import React from 'react'
import { CountdownTimer } from '@web/components/page-components/CountdownTimer'
import { ComponentType } from '@web/graphql-components'
import ProgressBar from './ProgressBar'
import { Video } from '@web/components/page-components/Video'
import { Image } from '@web/components/page-components/Image'
import { Footer } from '@web/components/page-components/Footer'
import { BaseComponent } from '@web/components/page-components/BaseComponent'
import { DonationForm } from './DonationForm'
import Row from './Row'
import Column from './Column'
import Comments from './Comments/Comments'
import DollarHandles from './DollarHandles'
import SocialShare from './SocialShare'
import { Text } from './Text'
import { PageComponentProps } from '@web/components/page-components/utils'
import Header from './Header'
import FundraiserProfile from './FundraiserProfile/FundraiserProfile'
import Leaderboard from './Leaderboard'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import Button from './Button'
import { useHttpClient } from 'apps/fe-donation/libs/hooks/useHttpClient'
import ProgressImage from './ProgressImage'
import VirtualGiftSection from './VirtualGiftSection/VirtualGiftSection'
import {
  VirtualGiftSectionPreviewImage,
  VirtualGiftSectionQuantity,
} from '@web/components/page-components/VirtualGiftSection'
import VirtualGiftPaymentForm from './VirtualGiftSection/VirtualGiftPaymentForm'
import VirtualGiftSectionPersonalisation from './VirtualGiftSection/VirtualGiftSectionPersonalisation'
import VirtualGiftSectionItemDownload from './VirtualGiftSection/VirtualGiftSectionItemDownload'
import PostDonationForm from './PostDonationForm'

// We want to accept any component type here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const COMPONENTS: { [key in ComponentType]: any } = {
  [ComponentType.DonationForm]: DonationForm,
  [ComponentType.ProgressBar]: ProgressBar,
  [ComponentType.Empty]: () => <div></div>,
  [ComponentType.Image]: Image,
  [ComponentType.Text]: Text,
  [ComponentType.Row]: Row,
  [ComponentType.Column]: Column,
  [ComponentType.Video]: Video,
  [ComponentType.CountdownTimer]: CountdownTimer,
  [ComponentType.Header]: Header,
  [ComponentType.Comments]: Comments,
  [ComponentType.Footer]: Footer,
  [ComponentType.DollarHandles]: DollarHandles,
  [ComponentType.Button]: Button,
  [ComponentType.SocialShare]: SocialShare,
  [ComponentType.FundraiserButton]: () => null,
  [ComponentType.LoginForm]: LoginForm,
  [ComponentType.RegisterForm]: RegisterForm,
  [ComponentType.FundraiserProfile]: FundraiserProfile,
  [ComponentType.Leaderboard]: Leaderboard,
  [ComponentType.PageOptions]: () => null,
  [ComponentType.ProgressImage]: ProgressImage,
  [ComponentType.VirtualGiftSection]: VirtualGiftSection,
  [ComponentType.VirtualGiftAmountSelector]: VirtualGiftSectionQuantity,
  [ComponentType.VirtualGiftPersonalisation]: VirtualGiftSectionPersonalisation,
  [ComponentType.VirtualGiftPreviewImage]: VirtualGiftSectionPreviewImage,
  [ComponentType.VirtualGiftPaymentForm]: VirtualGiftPaymentForm,
  [ComponentType.VirtualGiftItemDownload]: VirtualGiftSectionItemDownload,
  [ComponentType.PostDonationForm]: PostDonationForm,
}

const PageComponent = (props: PageComponentProps) => {
  const component = props.allComponents?.get(props.id) ?? props.component
  const httpClient = useHttpClient({ isRelativeUrl: true })

  if (!component) {
    return null
  }

  return (
    <BaseComponent
      {...props}
      element={COMPONENTS[component.type]}
      component={component}
      errorBoundaryProps={{
        apiPrefix: '/api/',
        httpClient,
      }}
    />
  )
}

export default PageComponent
